import { PaymentFooterWrapper } from "components/PaymentButton/PaymentButton.styles";
import styled from "styled-components";

export const PayPalFooterWrapper = styled(PaymentFooterWrapper)`
  width: 100%;
`;

export const PayPalButtonPlaceholder = styled.div`
  width: 100%;
`;

export const PayPalButtonsContainer = styled.div`
  width: 100%;
  min-height: 48px;
  min-width: 0;
  line-height: 0;

  .paypal-buttons,
  .paypal-buttons-context-iframe,
  iframe {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
  }
`;
